var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{attrs:{"rounded":"","type":_vm.labelType,"size":"is-medium"}},[_vm._v(_vm._s(_vm.status.replace("_", " ")))])}
var staticRenderFns = []

export { render, staticRenderFns }